import React, { useState } from "react";
import { Card, CardTitle, Row, Button, Col } from "react-bootstrap";
import { getCertificateReservationApi } from "../../services/api";
import { postDataFromApi } from "../../services/commonServices";
import { toast } from "react-toastify";
import { getFormatedDate } from "../../services/commonFunction";
import moment from "moment";
const ReserveCertificate = () => {
    const [hasData, setHasData] = useState(false);
    const [isOverlayLoader, setIsOverlayLoader] = useState(false);
    const [nextPage, setNextPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [historyDetails, setHistoryDetails] = useState([]);
    // useEffect(() => {
    //     let isMounted = true;
    //     const fetchData = () => {
    //         if (isMounted) {
    //             // fetchHistory();
    //         }
    //     };

    //     fetchData();
    //     return () => {
    //         isMounted = false;
    //     };
    // }, []);

    const getAllReserveCertificateData = async (isNext = "") => {
        try {

            setIsOverlayLoader(true)
            let payload = {
                target_date: moment(new Date()).format("yyyy-MM-DD"),
            };

            let res
            let endPoint = getCertificateReservationApi;
            if (isNext) {
                endPoint = endPoint + `?page=${nextPage}`;
            }
            res = await postDataFromApi(endPoint, payload);
            if (res?.data?.status === 200) {
                setHasData(true);
                setHistoryDetails((prevData) => {
                    return isNext ? [
                        ...prevData,
                        ...res.data.data
                    ] : res.data.data
                }
                );
                setHasMore(res.data.total_pages !== res.data.current_page);
                setNextPage(res.data.current_page + 1);
            } else {
                toast.error(res.message, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (error) { }
        finally {
            setIsOverlayLoader(false)
        }
    };
    const icons = [
        { name: "success", icon: "bi bi-cloud-check" },
        { name: "rejected", icon: "bi bi-x-circle-fill" },
    ];
    return (
        <Row>
            <Col>
                <Card>
                    <CardTitle tag="h5" className="history_title">
                        <div>
                            # <i className="bi bi-chevron-right card-title-icon"></i>{" "} Reserve Certificate
                        </div>
                    </CardTitle>

                    <div className="historyContainer">
                        {hasData ? (
                            <Row className="autoWidthImportant sampleverification-table module-log-history module-log-history-creditnote">
                                <>
                                    <div className="renderList_table_heading my-2">
                                        <h2>Reserve Certificate</h2>
                                    </div>

                                    <div className="historyContainer">
                                        {historyDetails.length > 0 ? (
                                            historyDetails.map((item, itemIndex) => (
                                                <div
                                                    className="historyContainerItem"
                                                    key={"History" - itemIndex}
                                                >
                                                    <div className="historyContainerItemBox">
                                                        <div className="historyContainerAvatar">
                                                            {icons.map((sym, symIndex) =>
                                                                item?.status?.toLowerCase() === sym.name ? (
                                                                    <i className={sym.icon} key={"sym" - symIndex}></i>
                                                                ) : null
                                                            )}
                                                        </div>
                                                        <p>
                                                            {item.message?.replace('Certificate number', `Certificate number ${item.certificate_number}`)}
                                                        </p>
                                                    </div>

                                                </div>
                                            ))
                                        ) : (
                                            <div className="historyContainerItemBox">
                                                <p>No reservations found</p>
                                            </div>
                                        )}
                                        {hasMore && (
                                            <div className="load_more_btn">
                                                <Button
                                                    onClick={() => getAllReserveCertificateData(1)}
                                                    className="submitBtn"
                                                >
                                                    Load More
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </>
                            </Row>
                        ) : (
                            <div className="historyContainerItemBox">
                                <button
                                    type="button"
                                    className={`searchby_button`}
                                    onClick={() => getAllReserveCertificateData()}
                                >
                                    {"Reserve Certificate History"}
                                </button>
                            </div>
                        )}
                    </div>
                </Card>
            </Col>
        </Row>
    );
};

export default ReserveCertificate;